module.exports = __webpack_public_path__ + "static/media/light_fixture_floor_led.bdef27b6.png";